import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const deliveryNoteItemListTodo = createAsyncThunk('deliveryNoteItemList', async ({ id, navigate }) => {

    let data = id.map(e => e?.value)

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `delivery-note-item-list`,
            params: {
                'delivery_note_id': JSON.stringify(data),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const deliveryNoteItemListSlice = createSlice({
    name: 'deliveryNoteItemList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(deliveryNoteItemListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(deliveryNoteItemListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default deliveryNoteItemListSlice.reducer; 